window.Vue = require('vue').default;

Vue.component('checkout-app', () => import(/*webpackChunkName:"Checkout"*/'./components/frontend/Checkout.vue'));
Vue.component('stripe-payment', () => import(/*webpackChunkName:"Checkout"*/'./components/frontend/StripePayment.vue'));
Vue.component('chat-app', () => import(/*webpackChunkName:"chatApp"*/'./components/frontend/Chat.vue'));

